module.exports = __webpack_public_path__ + "img/4_1.bcbe8b93.png";